import React from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import { useDispatch, useSelector } from "react-redux";
import configureStore from "../../../store/configureStore";
import Bill from "./common/Bill";
import { history } from "../../../reducers";
import Loader from "../../common/Loader";
import { get_orgunit_details } from "../../../actions/action-orgunit";
import { get_debit_note_details } from "./actions/action-debitNote";
import NewBill from "./common/NewBill";

const store = configureStore();

function DebitNoteDetails() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { debitNoteDetails, showGlobalLoader } = useSelector(
    (state) => state.debitNote
  );
  const { OrgunitDetails } = useSelector((state) => state.orgunit);

  useEffect(() => {
    let debitId = window.location.pathname.split("/");
    debitId = debitId[3];
    console.log("debitId", debitId);

    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_debit_note_details(debitId, activeOuid));
      await dispatch(get_orgunit_details(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Debit Note Details" />
      <div className="AppPage container--narrow mt FBAppPage">
        <button
          className="bill_edit_btn mb"
          onClick={() =>
            history.push(
              `/${activeOuid}/edit-debit-note/${debitNoteDetails.id}`
            )
          }
        >
          Edit
        </button>
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <>
            <NewBill
              billDetails={debitNoteDetails}
              companyDetails={OrgunitDetails}
            />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default DebitNoteDetails;
